import { motion, useScroll, useTransform } from "framer-motion";

export default function ScrollScanner() {
  const { scrollYProgress } = useScroll();
  const y = useTransform(scrollYProgress, [0, 1], ["0vh", "100vh"]);
  const opacity = useTransform(scrollYProgress, [0, 0.05, 0.95, 1], [0, 0.6, 0.6, 0]);

  return (
    <motion.div
      aria-hidden
      style={{ y, opacity }}
      className="pointer-events-none fixed left-0 right-0 top-0 z-[60] h-px"
    >
      <div className="h-px w-full bg-gradient-to-r from-transparent via-accent to-transparent shadow-[0_0_18px_2px_hsl(var(--accent)/0.5)]" />
    </motion.div>
  );
}